/**
 * Created by Carsten Bühler
 * User: c.buehler on 14.09.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import * as DateFormat from '../utils/date-format.js';

const DateTimeDisplay = ({ timestamp, dateFormat, classNames, onClick }) => {

    if (!(timestamp && dateFormat)) {
        return <span className={'' + (classNames || '')} onClick={onClick && onClick.bind(this)}>---</span>;
    }

    return (<span className={'' + (classNames || '')}
                  onClick={onClick && onClick.bind(this)}>{dateFormat(timestamp)}</span>);
};

DateTimeDisplay.propTypes = {
    timestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classNames: PropTypes.string,
    dateFormat: PropTypes.func,
    onClick: PropTypes.func
};

DateTimeDisplay.defaultProps = {
    dateFormat: DateFormat.formatDateTimeNoSeconds
};

export default DateTimeDisplay;




// WEBPACK FOOTER //
// ./js/components/DateTimeDisplay.jsx